import getActionSource from './getActionSource';
import updateSelectedItemPart from './updateSelectedItemPart';
import { KeyCodes } from '@fluentui/react/lib/Utilities';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { ActionSource } from 'owa-mail-store';
import { ClientItem } from 'owa-mail-store';
import { logUserAction, SurfaceActionItem } from 'owa-surface-actions';
import * as React from 'react';

export default function getHandlerAndLogAction(
    handler: (
        ev?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: SurfaceActionItem
    ) => boolean | void,
    isMouse: boolean,
    datapointName: string,
    item: ClientItem,
    viewState: ItemViewState,
    actionSourceInProps: ActionSource
) {
    return (
        ev?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        actionItem?: SurfaceActionItem
    ) => {
        // Log the user action for all the surface actions
        logUserAction(
            false /*isCompose*/,
            datapointName,
            actionItem,
            getActionSource(actionItem, actionSourceInProps) as string
        );

        if (isMouse) {
            updateSelectedItemPart(item, viewState);
            handler(ev, actionItem);
        } else {
            if ((ev as React.KeyboardEvent<HTMLElement>).which == KeyCodes.enter) {
                ev.preventDefault();
                ev.stopPropagation();
                updateSelectedItemPart(item, viewState);
                handler(ev, actionItem);
            }
        }
    };
}
